export const ADMIN_EMAIL = "katkargaurav6@gmail.com";